import { WorkerContainer } from './WorkerContainer';

const name = 'WorkerContainer';

export { name, WorkerContainer };
